import { graphql } from '../../gql';

export const QUERY_TRANSITIONS_V3 = graphql(`
  query QueryTransitionsV3(
    $req: TransitionsV3Req
    # Defaulted TRUE so every existing caller keeps the full selection without
    # passing it. Only the assistant's flows-only read sets it false, which is
    # what removed the need for a second hand-written document.
    $withBreakdowns: Boolean! = true
  ) {
    transitions_v3(req: $req) {
      entities {
        id
        index
        short_name
        long_name
        metrics {
          flows_inflows {
            items {
              id
              short_name
              long_name
              count
              share
            }
          }
          flows_outflows {
            items {
              id
              short_name
              long_name
              count
              share
            }
          }
          breakdowns_inflows @include(if: $withBreakdowns) {
            role {
              id
              short_name
              long_name
              count
              share
            }
            rics {
              id
              short_name
              long_name
              count
              share
            }
            education {
              id
              short_name
              long_name
              count
              share
            }
            seniority {
              id
              short_name
              long_name
              count
              share
            }
            geography {
              id
              short_name
              long_name
              count
              share
            }
            ethnicity {
              id
              short_name
              long_name
              count
              share
            }
            gender {
              id
              short_name
              long_name
              count
              share
            }
          }
          breakdowns_current @include(if: $withBreakdowns) {
            gender {
              id
              short_name
              long_name
              count
              share
            }
            rics {
              id
              short_name
              long_name
              count
              share
            }
            education {
              id
              short_name
              long_name
              count
              share
            }
            seniority {
              id
              short_name
              long_name
              count
              share
            }
            role {
              id
              short_name
              long_name
              count
              share
            }
            geography {
              id
              short_name
              long_name
              count
              share
            }
            ethnicity {
              id
              short_name
              long_name
              count
              share
            }
          }
          breakdowns_outflows @include(if: $withBreakdowns) {
            rics {
              id
              short_name
              long_name
              count
              share
            }
            education {
              id
              short_name
              long_name
              count
              share
            }
            seniority {
              id
              short_name
              long_name
              count
              share
            }
            role {
              id
              short_name
              long_name
              count
              share
            }
            geography {
              id
              short_name
              long_name
              count
              share
            }
            ethnicity {
              id
              short_name
              long_name
              count
              share
            }
            gender {
              id
              short_name
              long_name
              count
              share
            }
          }
        }
      }
    }
  }
`);
